import { Injectable, Provider } from '@angular/core';
import { PerfilService as AjsPerfilService } from '../../angularjs-app/services/perfil/perfil.service';

export interface BetaFeature {
  codigo: string;
  possuiAcesso: boolean;
}

export interface BetaFeatureResponse {
  funcionalidades: BetaFeature[];
}

@Injectable()
export class PerfilService implements AjsPerfilService {
  userData: any;
  userActiveAddress: any;
  $state: any;
  PerfilResource: any;
  localStorageService: any;
  Pedido: any;

  setActiveAddress(userAddressList: any): void {
    throw new Error('Method not implemented.');
  }
  setUserData(user: any): void {
    throw new Error('Method not implemented.');
  }
  async getClienteData(userId: any): Promise<any> {
    throw new Error('Method not implemented.');
  }
  async getUserData(ignoreCache: any): Promise<any> {
    throw new Error('Method not implemented.');
  }
  async getActiveAddress(goBack: any): Promise<any> {
    throw new Error('Method not implemented.');
  }
  async saveUserData(user: any): Promise<any> {
    throw new Error('Method not implemented.');
  }
  getCacheUserData(): any {
    return { categoriaCliente: {} };
  }
  isActiveAddress(enderecos: any): boolean {
    throw new Error('Method not implemented.');
  }
  updateAddress(addressList: any): void {
    throw new Error('Method not implemented.');
  }
  verificarCadastro(user: any) {
    throw new Error('Method not implemented.');
  }
  async getBetaFeatures(): Promise<BetaFeatureResponse> {
    throw new Error('Method not implemented.');
  }
  async liberarFormaDePagamento(controller: any): Promise<void> {
    throw new Error('Method not implemented.');
  }
  async saveHooks(hooks: any): Promise<any> {
    throw new Error('Method not implemented.');
  }
  async getToken(): Promise<any> {
    throw new Error('Method not implemented.');
  }
  verifyActiveAddress(addressList: any) {
    throw new Error('Method not implemented.');
  }
  async connectPayPal(): Promise<any> {
    throw new Error('Method not implemented.');
  }

}

export function PerfilServiceFactory(i: any) {
  return i.get('Perfil');
}

export const PerfilServiceProvider: Provider = {
  provide: PerfilService,
  useFactory: PerfilServiceFactory,
  deps: ['$injector'],
};
